import { render, staticRenderFns } from "./404.vue?vue&type=template&id=d989eb38&scoped=true&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"
import style0 from "./404.vue?vue&type=style&index=0&id=d989eb38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d989eb38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d989eb38')) {
      api.createRecord('d989eb38', component.options)
    } else {
      api.reload('d989eb38', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=d989eb38&scoped=true&", function () {
      api.rerender('d989eb38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/404.vue"
export default component.exports